// extracted by mini-css-extract-plugin
export default {"likeBtn":"LikeBtn_likeBtn__Gb5a4","liked":"LikeBtn_liked__2h1CR","count":"LikeBtn_count__aTJgL"};